const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let scriptPromise;

const loadRecaptcha = () => {
  if (!SITE_KEY) {
    return Promise.reject(new Error("reCAPTCHA is not configured."));
  }

  if (window.grecaptcha) {
    return Promise.resolve(window.grecaptcha);
  }

  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-susegado-recaptcha="true"]');
      if (existing) {
        existing.addEventListener("load", () => resolve(window.grecaptcha), { once: true });
        existing.addEventListener("error", () => reject(new Error("Could not load reCAPTCHA.")), { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(SITE_KEY)}`;
      script.async = true;
      script.defer = true;
      script.dataset.susegadoRecaptcha = "true";
      script.onload = () => resolve(window.grecaptcha);
      script.onerror = () => reject(new Error("Could not load reCAPTCHA."));
      document.head.appendChild(script);
    });
  }

  return scriptPromise;
};

export const getRecaptchaToken = async (action) => {
  const grecaptcha = await loadRecaptcha();

  if (!grecaptcha) {
    throw new Error("reCAPTCHA is unavailable.");
  }

  return new Promise((resolve, reject) => {
    grecaptcha.ready(() => {
      grecaptcha.execute(SITE_KEY, { action }).then(resolve).catch(reject);
    });
  });
};
